import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import { ChakraProvider } from "@chakra-ui/react";
import "./utils/i18n.ts";
import { ColorModeProvider } from "./components/ui/color-mode";
import { SipProvider } from "./services/sip";
import { Analytics, MixpanelProvider } from "./services/analytics";
import { system } from "./theme";
import { store } from "./store";
import { PostHogProvider, PostHogErrorBoundary } from "@posthog/react";
import App from "./App";

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

import { FallbackComponent } from "./components/FallbackComponent";

// Initialize analytics
const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN;
if (mixpanelToken) {
  Analytics.init(new MixpanelProvider(mixpanelToken));
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <PostHogErrorBoundary fallback={<FallbackComponent />}>
        <CookiesProvider>
          <Provider store={store}>
            <ChakraProvider value={system}>
              <ColorModeProvider>
                <SipProvider>
                  <App />
                </SipProvider>
              </ColorModeProvider>
            </ChakraProvider>
          </Provider>
        </CookiesProvider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>,
);
